module.exports = __webpack_public_path__ + "static/media/downArrow.ee0ccb6a.svg";